import React from 'react';
import {
  Margin,
  ContentGrid,
  Row,
  Col,
  SecondaryCTAButton,
  PrimaryCTAButton,
} from '@ovotech/element-v4';
import {
  CenteredCol,
  StepIndicator,
  Divider,
  StyledChevronRight,
} from './PreEligibilityProducts.styled';
import ChevronRight from '@/src/resources/chargeAnytime/chevron-right.svg';

type ModalTab = 'what-you-get' | 'need-to-know';

interface ModalStepRendererProps {
  steps: React.FC[];
  onClose: () => void;
  currentTab: ModalTab;
  currentStep: number;
  onNextStep: () => void;
  onPrevStep: () => void;
}

export const ModalStepRenderer: React.FC<ModalStepRendererProps> = ({
  steps,
  currentStep,
  onPrevStep,
  onNextStep,
  onClose,
}) => {
  const maxSteps = steps.length;
  const StepComponent = steps[currentStep - 1];

  return (
    <div>
      {StepComponent && <StepComponent />}

      <Margin top={4} />

      <Divider />

      <Margin top={4}>
        <ContentGrid size="12">
          <Row isNested style={{ alignItems: 'center' }}>
            <Col small={4}>
              {currentStep > 1 ? (
                <SecondaryCTAButton onClick={onPrevStep}>
                  Back
                </SecondaryCTAButton>
              ) : (
                <SecondaryCTAButton onClick={onClose}>Close</SecondaryCTAButton>
              )}
            </Col>

            <CenteredCol small={4}>
              <StepIndicator>
                {currentStep} of {maxSteps}
              </StepIndicator>
            </CenteredCol>

            <Col small={4} style={{ textAlign: 'right' }}>
              {currentStep < maxSteps ? (
                <PrimaryCTAButton onClick={onNextStep}>
                  Next{' '}
                  <StyledChevronRight src={ChevronRight} alt="Chevron right" />
                </PrimaryCTAButton>
              ) : (
                <PrimaryCTAButton onClick={onClose}>Close</PrimaryCTAButton>
              )}
            </Col>
          </Row>
        </ContentGrid>
      </Margin>
    </div>
  );
};
